import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import moment from "moment/moment";

export default function useUpdateMaturityDate(state) {
    const beneficiary = state.beneficiary;
    const plan = state.plan;
    const setPlan = state.setPlan;

    //We  can set the Maturity Date to be 18 years after the birthdate, if the maturity date hasn't been set yet.
    //We use the 18th year based on birthdate, but the month and day from the effective date
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!plan.effectiveDate || !beneficiary.birthdate) return;

        let maturityDate = moment(beneficiary.birthdate).add(18, 'years');
        maturityDate.month(moment(plan.effectiveDate).month());
        maturityDate.date(moment(plan.effectiveDate).date());
        const newMaturityDate = moment(maturityDate).toDate().toISOString().substring(0, 10);

        setPlan(prevData => ({...prevData, maturityDate: newMaturityDate}));

        debugLog("useUpdateMaturityDate");
    }, [beneficiary.birthdate, plan.effectiveDate]);



    const plan2 = state.plan2;
    const setPlan2 = state.setPlan2;
    //We  can set the Maturity Date to be 18 years after the birthdate, if the maturity date hasn't been set yet.
    //We use the 18th year based on birthdate, but the month and day from the effective date
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!plan2.effectiveDate || !beneficiary.birthdate) return;

        let maturityDate = moment(beneficiary.birthdate).add(18, 'years');
        maturityDate.month(moment(plan2.effectiveDate).month());
        maturityDate.date(moment(plan2.effectiveDate).date());
        const newMaturityDate = moment(maturityDate).toDate().toISOString().substring(0, 10);

        setPlan2(prevData => ({...prevData, maturityDate: newMaturityDate}));

        debugLog("useUpdateMaturityDate");
    }, [beneficiary.birthdate, plan2.effectiveDate]);

}